// extracted by mini-css-extract-plugin
export var button__primary = "styles-module--button__primary--8e3f5";
export var cursor = "styles-module--cursor--34564";
export var cursorFollower = "styles-module--cursor-follower--100ee";
export var headingCentered = "styles-module--heading-centered--6357e";
export var noScroll = "styles-module--no-scroll--bd40e";
export var pageTemplatePageGame = "styles-module--page-template-page-game--ed5d7";
export var section__wrapper = "styles-module--section__wrapper--73716";
export var section__wrapperLarge = "styles-module--section__wrapper--large--17004";
export var tenetItem = "styles-module--tenet-item--c8ed4";
export var tenetItemIcon = "styles-module--tenet-item-icon--ab9eb";
export var tenetItemTitle = "styles-module--tenet-item-title--c2fab";
export var tenetSlider = "styles-module--tenet-slider--59a98";